import React, {useState} from 'react';
import { AmplifyContainer } from "@aws-amplify/ui-react";
import {Button, Card, Col, Container, Form, Row, Spinner} from "react-bootstrap";
import Alert from "../alert/alert";
import {changeAuthState, cognitoForgotPassword, cognitoSendCode} from "../../helpr/authHelper";
import {AuthState} from "@aws-amplify/ui-components";
import {AUTH_INVALID_PASSWORD, AUTH_INVALID_USERNAME,
  AUTH_INVALID_CODE, AUTH_SEND_CODE_SUCCESS, AUTH_FORGOT_PASSWORD_SUCCESS} from "../../helpr/constants";
import styles from './custom-forgot-password.module.scss'
import usernameIcon from "../../assets/login-username-icon.svg";
import passwordIcon from "../../assets/login-password-icon.svg";

const CustomForgotPasswordContainer = () => {
  return (
    <AmplifyContainer className={styles['custom-container']} slot="forgot-password">
      <CustomForgotPassword />
    </AmplifyContainer>
  )
}

export const CustomForgotPassword = () => {
  /*
    Initiate forgot password general form state
   */
  const [forgotPasswordState, setForgotPasswordState] = useState({
    onForgot: false,
    onReset: false
  });
  /*
    State for showing send code or reset password
   */
  const [showReset, setShowReset] = useState(false);
  /*
    Initiate show alert state
   */
  const [showErr, setShowErr] = useState({
    msg: '',
    type: '',
    isVisible: false,
    onClose: ()=>setShowErr({
      ...showErr,
      ['isVisible']: false
    }),
  });

  /*
    Set sign in form on change of fields
   */
  const onChange = (e) => {
    const value = e.target.value;
    setForgotPasswordState({
      ...forgotPasswordState,
      [e.target.id]: value.trim()
    });
  }

  /*
    Send verification code to registered email
   */
  const sendCode = async (e) => {
    e.preventDefault();
    setForgotPasswordState({
      ...forgotPasswordState,
      onForgot: true
    });
    try {
      const { fpUsername } = forgotPasswordState;
      if (!fpUsername) {
        throw new Error(AUTH_INVALID_USERNAME);
      }

      const data = await cognitoSendCode(fpUsername);
      if (data) {
        setShowErr({
          ...showErr,
          ['isVisible']: true,
          msg: AUTH_SEND_CODE_SUCCESS,
          type: 'alert-success-custom',
        });
      }
      document.getElementById("send-code").reset();
      setShowReset(true);
    } catch (error) {
      /*
        Display error message in UI
       */
      setShowErr({
        ...showErr,
        ['isVisible']: true,
        msg: error.message,
        type: 'alert-danger-custom',
      });
      console.log('error loggin in:', error.message);
    } finally {
      setForgotPasswordState({
        ...forgotPasswordState,
        onForgot: false
      });
    }
  }

  /*
    Reset password
   */
  const resetPassword = async (e) => {
    e.preventDefault();
    setForgotPasswordState({
      ...forgotPasswordState,
      onReset: true
    });
    try {
      const { fpUsername, fpCode, fpPassword } = forgotPasswordState;
      if (!fpCode) {
        throw new Error(AUTH_INVALID_CODE);
      }
      if (!fpPassword) {
        throw new Error(AUTH_INVALID_PASSWORD);
      }

      await cognitoForgotPassword(fpUsername, fpCode, fpPassword);
      setShowErr({
        ...showErr,
        ['isVisible']: true,
        msg: AUTH_FORGOT_PASSWORD_SUCCESS,
        type: 'alert-success-custom',
        onClose: async () => {
          setShowErr({
            ...showErr,
            ['isVisible']: false
          });
          document.getElementById("reset-password").reset();
          await changeAuthState(AuthState.SignIn);
          setShowReset(false);
          setForgotPasswordState({});
        }
      });
    } catch (error) {
      /*
        Display error message in UI
       */
      setShowErr({
        ...showErr,
        ['isVisible']: true,
        msg: error.message,
        type: 'alert-danger-custom',
      });
      console.log('error loggin in:', error.message);
    } finally {
      setForgotPasswordState({
        ...forgotPasswordState,
        onReset: false
      });
    }
  }

  /*
    Handle forgot password
   */
  const handleBackToSignIn = async () => {
    await changeAuthState(AuthState.SignIn);
    setShowReset(false);
    setForgotPasswordState({});
  }

  return (
    <Container>
      <Row>
        <Col lg={{ span: 4, offset: 4 }}>
          <div className="login-wrapper">
            <Alert
              options={showErr}
              onClose={()=>setShowErr({
                ...showErr,
                ['isVisible']: false
              })} />
            {!showReset
              ?
              <div>
                <div className={styles['header']}>
                  <h3>Forgot your password?</h3>
                  <span>A verification code will be sent to your registered email</span>
                </div>
                <div className={styles['form-section']}>
                  <Form id="send-code" onSubmit={sendCode}>
                    <Form.Group className={styles['input-section']} controlId="fpUsername">
                      <i className={styles['icon']}><img src={usernameIcon} /></i>
                      <Form.Control
                        aria-label="fpUsername"
                        type="text"
                        placeholder="Username"
                        className={styles['forgot-pw-input']}
                        onChange={onChange}/>
                    </Form.Group>
                    <div className="login-button">
                      <Button disabled={forgotPasswordState.onForgot} variant="primary" type="submit">
                        {forgotPasswordState.onForgot ? <Spinner size="sm" animation="border"/> : 'SEND CODE'}
                      </Button>
                    </div>
                  </Form>
                </div>
              </div>
              :
              <div>
                <div>
                  <h3>Reset your password</h3>
                </div>
                <div className={styles['form-section']}>
                  <Form id="reset-password" onSubmit={resetPassword}>
                    <Form.Group className={styles['input-section']}  controlId="fpCode">
                      <i className={styles['icon']}><img src={passwordIcon} /></i>
                      <Form.Control
                        className={styles['forgot-pw-input']}
                        aria-label="fpCode"
                        type="text"
                        placeholder="Verification Code"
                        onChange={onChange}/>
                    </Form.Group>
                    <Form.Group className={styles['input-section']} controlId="fpPassword">
                      <i className={styles['icon']}><img src={passwordIcon} /></i>
                      <Form.Control
                        className={styles['forgot-pw-input']}
                        type="password"
                        placeholder="Password"
                        onChange={onChange}/>
                    </Form.Group>
                    <div className="login-button">
                      <Button disabled={forgotPasswordState.onReset} variant="primary" type="submit">
                        {forgotPasswordState.onReset ? <Spinner size="sm" animation="border"/> : 'RESET PASSWORD'}
                      </Button>
                    </div>
                  </Form>
                </div>
              </div>
            }
            <div className={styles['login-options']}>
              <a href="#" onClick={handleBackToSignIn}>Back to Sign In</a>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  )
}

export default CustomForgotPasswordContainer;
